module.exports = __webpack_public_path__ + "static/media/27OCHA18.1d5f8bbf.jpg";